import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from "@angular/core";
import {Adapter} from "../../person-autocomplete/person-autocomplete.component";
import {ActivatedRoute} from "@angular/router";
import {map} from "rxjs/operators";
import {Pageable} from "../../../model/rest/base";
import {NgForm} from "@angular/forms";
import {GroupMember, V3Student, V3Teacher} from "../../../model/v3/schools";
import {GroupV3RestService} from "../../../services/rest/v3/group-rest.service";
import {TeacherV3RestService} from "../../../services/rest/v3/teacher-rest.service";
import {StudentV3RestService} from "../../../services/rest/v3/student-rest.service";

@Component({
    template: '',
    standalone: false
})
export abstract class GroupParticipantCreate<P extends V3Student | V3Teacher> implements OnInit {
  schoolId: number;
  pageable = Pageable.of(0, 10, [])
  isLoading = false
  participantAdapter: Adapter<P>;
  participant: GroupMember<P>
  isParticipantBeingAdded = false
  isParticipantBeingEdited = false
  labels = ""
  isParticipantSelected = false
  @Input() groupId: number
  @Output() reloadGroupEmitter = new EventEmitter<void>()
  @ViewChild('groupParticipantForm') groupParticipantForm: NgForm
  protected constructor(protected activatedRoute: ActivatedRoute,
                        protected groupV3Rest: GroupV3RestService,
                        protected studentV3Rest: StudentV3RestService,
                        protected teacherV3Rest: TeacherV3RestService
  ) {
    activatedRoute.paramMap.pipe(
      map(params => {
        this.schoolId = Number(params.get('schoolId'))
      })
    ).subscribe(_ => this.setupAutocompleteAdapters());
  }

  ngOnInit(): void {
  }

  abstract resetParticipantObject(): void

  abstract setupAutocompleteAdapters(): void

  abstract addParticipant(): void

  abstract participantSelected(parti: GroupMember<P>, selectedParti: P): void

  abstract saveParticipant(): void

  prepareParticipantEdition(parti: GroupMember<P>) {
    this.isParticipantBeingEdited = true
    this.addParticipant()
    this.participantSelected(parti, parti.member)
    this.labels = this.participant.labels.join(', ')
  }

  unlinkParticipant() {
    this.isParticipantSelected = false
  }

  cancelAddingParticipant() {
    this.isParticipantBeingAdded = false
    this.isParticipantSelected = false
    this.resetParticipantObject()
  }
}

